// extracted by mini-css-extract-plugin
export default {"JobStatus":"styles_JobStatus__fSAk3","jobStatus":"styles_jobStatus__Akv+4","green":"styles_green__Zpgc3","orange":"styles_orange__87Nm5"};